import styled, { css } from 'styled-components'
import { FullWidthWrapper } from '../../Container/Container.style'

export const TextImageGridContainer = styled(FullWidthWrapper)`
  padding: 0;
  margin-top: 3.2rem;
  margin-bottom: 0;
  background-color: ${props => props.theme.colors.white};

  ${props => props.stickToTop && css`
    ${TextImageGridWrapper} {
      justify-content: flex-end;
    }

    ${IconContainer} {
      position: fixed;
      top: 8rem;
      left: 2rem;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        left: ${(props) => props.leftPos + 'px'};
        padding-left: 2rem;
        top: 12rem;
      }

      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        padding-left: 0;
      }
    }
  `}

  &:last-of-type {
    margin-bottom: 6.4rem;
  }
`

export const TextImageGridWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 4.8rem 2rem 0;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    padding: 0;
    padding-top: 6.4rem;
  }
`

export const ProductDetails = styled.div`
  text-align: center;
  margin-left: 1.5rem;
  width: 70%;
  max-width: 22.4rem;

  .productDescription {
    text-align: left;
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-left: 4.1rem;
    text-align: left;
    max-width: 46.9rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    max-width: 72.3rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    max-width: 75.5rem;
  }

  h4 {
    margin: 2rem 0;
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      margin: 0;
    }
    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 13.8rem;
      margin: 1.8rem auto 0;
      @media screen and (min-width: ${props =>
    props.theme.responsive.small}) {
        margin: 1.2rem 0 2.4rem;
      }
    }
  }
  ul li {
    display: flex;
    margin-bottom: 2rem;
    flex-direction: column;
    border-bottom: 1px solid ${props => props.theme.colors.black};
    padding-bottom: 4.8rem;
    margin-bottom: 5.6rem;

    &:last-child {
      border-bottom: none;
      margin: 0;
    }
    p {
      font-size: 1.4rem;
    }

    img {
      align-self: flex-start;
      max-width: 19.4rem;
      height: auto;
      margin-left: auto;
      margin-right: auto;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        margin: 0;
      }

      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        max-width: 35.8rem;
      }
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;
      align-self: flex-start;
      align-content: flex-start;
      padding-bottom: 6.4rem;

      .description {
        margin-left: 4rem;
      }
    }
  }
`

export const IconContainer = styled.div`
  width: 27%;

  ul {
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;
    }

    li {
      margin-bottom: 1.6rem;
      width: 8.7rem;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        margin-right: 1.6rem;
        width: 10.1rem;

        &:last-child {
          margin-right: 0;
        }
      }

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        width: 13.2rem;
      }
    }
  }
`
